module.exports = __webpack_public_path__ + "static/EnmTX_BosSnake_L_A_cl-c5c58e9716da41c3645d19024adf01d6.gif";